import React from 'react';
import { Button, ButtonGroup } from "react-bootstrap";

const Row = ({ booster, onRemove, onUpdate}) => {
    return (<tr>
        <td style={{ textAlign: 'left' }}>{booster.updated}</td>
        <td style={{ textAlign: 'left' }}>{booster.feed}</td>
        <td>{booster.subid}</td>
        <td>{booster.country}</td>
        <td>{booster.factor}</td>
        <td>
            <ButtonGroup>
                <Button bsStyle="info" onClick={() => onUpdate(booster)}>Update</Button>
                <Button bsStyle="danger" onClick={() => onRemove(booster.id)}>Remove</Button>
            </ButtonGroup>
        </td>
    </tr>);
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/AdkBoosters/components/Table/components/Row/index.js